module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAAqCAYAAAATZhM+AAAAAXNSR0IArs4c6QAAALdJREFUaEPtmcEJxCAABE0HlmMJ2oJge7ZgSZcuEszj4J4LgT2T8b247kx+2XLOn/Cws8UYjydtSint16hSSmitLb+t1hp+RvXelx41xgiMWkEhplawNN+IKUwZCfD5GeFL1ZiScBnDmDLCl6oxJeEyhjFlhC9VY0rCZQxjyghfqsaUhMsYxpQRvlSNKQmXMYwpI3ypGlMSLmMYU0b4UjWmJFzG8HtMGSHfVj1tff/O33brH1w0R52oRFaQxZ8cwgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page/crop/five-to-four.png
// module id = qREj
// module chunks = 3